import React, { FC } from 'react';

import LabelChip from '../../../../../components/labels/LabelChip';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../../constants/aampeTheme';

// models
import { GamificationItemModel } from '../../../../../models/label.model';

// components
import GamificationProgressBar from './GamificationProgressBar';

interface LabelGamificationRowProps {
    color: string;
    gamificationItem: GamificationItemModel;
}

const LabelGamificationRow: FC<
    React.PropsWithChildren<LabelGamificationRowProps>
> = ({ gamificationItem, color }) => {
    return (
        <LabelListItem>
            <StyledChip title={gamificationItem.label_name} />
            <GamificationProgressBar
                count={gamificationItem.count}
                color={color}
            />
        </LabelListItem>
    );
};

export default LabelGamificationRow;

const LabelListItem = styled.div({
    display: 'flex',
    alignItems: 'center',
});

const StyledChip = styled(LabelChip)({
    flex: 1,
    '& > span': {
        color: aampeTheme.colors.neutral09,
        opacity: 1,
    },
});
